import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Params, Router } from '@angular/router';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

@Component({
  selector: 'app-sidebar-list',
  templateUrl: './sidebar-list.component.html',
  styleUrls: ['./sidebar-list.component.scss'],
})
export class SidebarListComponent implements OnInit {
  @Output() sidebarClose = new EventEmitter<void>();
  @Input() userName: string;

  navList: { name: string; path: string; icon?: string; query?: Params }[] = [];

  *navListGenerator() {
    yield { name: 'Dashboard', path: 'dashboard' };
    if (this.appConfigService.tenant?.portalConfiguration?.showProfileTab) {
      yield { name: 'Profile', path: 'profile' };
    }
    if (this.appConfigService.tenant?.portalConfiguration?.showCredentialTab) {
      yield {
        name: this.appConfigService.tenant.portalConfiguration.credentialTabLabel ?? 'Credentials',
        path: 'credentials',
      };
    }
    yield { name: 'Reports & Documents', path: 'reports-documents' };
    yield { name: 'Messages', path: 'messages' };
    yield { name: 'Payments', path: 'payments' };
  }

  constructor(private router: Router, private appConfigService: AppConfigService) {}

  ngOnInit() {
    this.navList = [...this.navListGenerator()];
  }
  isLinkActive(url): boolean {
    const queryParamsIndex = this.router.url.indexOf('?');
    const baseUrl =
      queryParamsIndex === -1 ? this.router.url : this.router.url.slice(0, queryParamsIndex);
    return baseUrl.startsWith(url);
  }
  onClose() {
    this.sidebarClose.emit();
  }
}
